import * as React from 'react';

import F1 from '@/assets/icons/icon_f1.svg';
import F2 from '@/assets/icons/icon_f2.svg';
import G1 from '@/assets/icons/icon_g1.svg';
import G2 from '@/assets/icons/icon_g2.svg';
import G3 from '@/assets/icons/icon_g3.svg';
import GP from '@/assets/icons/icon_gp.svg';
import { toHalfWidth } from '@/utility/utils';

interface GradeProps {
  gradeName: string;
  width?: string;
  height?: string;
}

const GradeIcon: React.FC<GradeProps> = ({
  gradeName,
  width = '24px',
  height = '16px',
}) => {
  const styles = { width, height };

  switch (toHalfWidth(gradeName)) {
    case 'GP': {
      return <img src={GP} style={{ ...styles }} alt="GPレース" />;
    }
    case 'G1': {
      return <img src={G1} style={{ ...styles }} alt="G1レース" />;
    }
    case 'G2': {
      return <img src={G2} style={{ ...styles }} alt="G2レース" />;
    }
    case 'G3': {
      return <img src={G3} style={{ ...styles }} alt="G3レース" />;
    }
    case 'F1': {
      return <img src={F1} style={{ ...styles }} alt="F1レース" />;
    }
    case 'F2': {
      return <img src={F2} style={{ ...styles }} alt="F2レース" />;
    }
    default: {
      return <></>;
    }
  }
};

export default GradeIcon;
